export default __webpack_public_path__ + "static/media/job_offer19_m.dca362ae.jpg";